import { Outlet } from "react-router-dom";
import Navbar from "@/components/Navbar";
import Footer from "@/components/Footer";
import ScrollToTop from "@/components/ScrollToTop";
import BookingOverlay from "@/components/BookingOverlay";

export default function Layout() {
  return (
    <div className="relative min-h-screen overflow-x-clip bg-[#fff7e8] text-[#241c0d]">
      <div className="grain" aria-hidden="true" />
      <ScrollToTop />
      <Navbar />
      <main>
        <Outlet />
      </main>
      <Footer />
      <BookingOverlay />
    </div>
  );
}
